// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card__header {
  padding: 16px 20px;
  border-bottom: 1px solid #edf0f2;
}

.skl-card__body {
  padding: 20px;
}

.skl-table-wrap {
  border: 1px solid #edf0f2;
  border-radius: 4px;
  overflow: hidden;
}

.skl-row {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr 0.8fr 0.7fr 0.9fr 0.8fr 1.2fr 0.8fr;
}

.skl-row--header,
.skl-row--filters {
  background: #f8f9fa;
}

.skl-row--data + .skl-row--data {
  border-top: 1px solid #edf0f2;
}

.skl-cell {
  display: flex;
  align-items: center;
  min-height: 54px;
  padding: 10px 12px;
}

.skl-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
}

.skl-pagination-buttons {
  display: flex;
  gap: 4px;
}

@media (max-width: 991.98px) {
  .skl-row {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 575.98px) {
  .skl-pagination {
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/modernization-readiness/job-logs-table-skeleton/job-logs-table-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sEAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE;IACE,gDAAA;EACF;AACF;AAEA;EACE;IACE,eAAA;IACA,2BAAA;IACA,SAAA;EAAF;AACF","sourcesContent":[".skl-card {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card__header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #edf0f2;\n}\n\n.skl-card__body {\n  padding: 20px;\n}\n\n.skl-table-wrap {\n  border: 1px solid #edf0f2;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.skl-row {\n  display: grid;\n  grid-template-columns: 1.2fr 0.8fr 0.8fr 0.7fr 0.9fr 0.8fr 1.2fr 0.8fr;\n}\n\n.skl-row--header,\n.skl-row--filters {\n  background: #f8f9fa;\n}\n\n.skl-row--data + .skl-row--data {\n  border-top: 1px solid #edf0f2;\n}\n\n.skl-cell {\n  display: flex;\n  align-items: center;\n  min-height: 54px;\n  padding: 10px 12px;\n}\n\n.skl-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 18px;\n}\n\n.skl-pagination-buttons {\n  display: flex;\n  gap: 4px;\n}\n\n@media (max-width: 991.98px) {\n  .skl-row {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 575.98px) {\n  .skl-pagination {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    gap: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
